<script setup>
  import {computed, inject} from "vue";

  import {area as areaEnum} from "@pages/Records/Components/Result/Enums.js";
  import PagesRecordResultListClaimItem from "@pages/Records/Components/Result/ResultList/ListClaimItem.vue";

  defineOptions({
    name: "PagesRecordResultListClaims",
  });

  const props = defineProps({
    patientId: {
      type: String,
      required: true,
    },
    recordId: {
      type: String,
      required: true,
    },
    mcCheckId: {
      type: Number,
      required: true,
    },
    claims: {
      type: Array,
      required: true,
    },
    area: {
      type: String,
      default: areaEnum.prognostic,
    },
  });

  defineEmits(["open:shareDialog"]);

  const resultConfig = inject("resultConfig");

  const isAiPrioritized = (claim) => resultConfig.value.aiPrioritizedClaims?.includes(claim.section) ?? false;

  /**
   * Returns an array of check.id from checks, which are communicated
   */
  const claimsForArea = computed(() => {
    return props.claims.filter((claimData) => {
      return claimData.area === props.area;
    });
  });
</script>

<template>
  <ol class="list-none">
    <li
      v-for="(claim, index) in claimsForArea"
      :key="claim.id"
      :class="{'opacity-50 hover:opacity-100': claim.hidden}"
      :data-test="getTestId(`claims-${index}`)"
    >
      <PagesRecordResultListClaimItem
        :patient-id="patientId"
        :record-id="recordId"
        :mc-check-id="mcCheckId"
        :claim="claim"
        :claim-number="index + 1"
        :has-sibling-claims="claimsForArea.length > 1"
        :ai-prioritized="isAiPrioritized(claim)"
        :test-id="getTestId(`claims-${index}`)"
        @open:share-dialog="$emit('open:shareDialog')"
      />
    </li>
  </ol>
</template>
